

























import { mapState } from 'vuex';
import Vue from 'vue';

require('firebase/app').initializeApp({
	databaseURL: process.env.VUE_APP_DATABASE_URL,
	apiKey: process.env.VUE_APP_API_KEY,
	authDomain: process.env.VUE_APP_AUTH_DOMAIN,
	projectId: process.env.VUE_APP_PROJECT_ID,
	storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
	appId: process.env.VUE_APP_APP_ID,
	measurementId: process.env.VUE_APP_MEASUREMENT_ID
});

import Menu from '@/views/Menu.vue';
import ContactMe from '@/views/ContactMe.vue';

export default Vue.extend({
	name: 'App',

	data() {
		return {
			ProfilePic: process.env.VUE_APP_MEDIA_FOLDER + '/ProfilePic.png',
			Title: process.env.VUE_APP_TITLE,
			Name: process.env.VUE_APP_NAME
		};
	},

	components: {
		ContactMe,
		Menu
	}
});
